// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-pagination[data-v-40a648f6] {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 0.9375px solid #cbd2d9;\n  font-weight: 500;\n  font-size: 18.75px;\n  line-height: 120%;\n  color: #cbd2d9;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.btn-pagination.active[data-v-40a648f6] {\n  background: #3ce8da;\n  color: #412dcd;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
